import { jsxs as x, jsx as t, Fragment as L } from "react/jsx-runtime";
import * as c from "react";
import { forwardRef as f, useRef as $, useImperativeHandle as P, useMemo as g, useState as ee, cloneElement as te, isValidElement as re, memo as ne } from "react";
import { c as p } from "./tw-cn-mXgPecoF.mjs";
import { c as R } from "./index.js-Cr0Rsuyz.mjs";
import { u as le } from "./use-focus-BGKOEgog.mjs";
import { I as O } from "./icon-button-CBGiAhhG.mjs";
import { c as A } from "./variance-DhhqoHkK.mjs";
function ae(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25m4.064 5.688a.75.75 0 0 0-1.06 0l-3.009 3.008-3.009-3.008a.75.75 0 0 0-1.06 1.06l3.009 3.009-3.002 3.002a.75.75 0 1 0 1.06 1.06l3.002-3.002 3.002 3.002a.75.75 0 0 0 1.06-1.06l-3.001-3.002 3.008-3.009a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  }));
}
var ie = R(/* @__PURE__ */ f(ae));
function se(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.339 4.722a.75.75 0 0 0-1.061-1.06L3.661 20.277a.75.75 0 1 0 1.06 1.06l3.46-3.459c1.223.44 2.524.683 3.819.683 4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64c-.562-1.43-1.602-2.715-2.923-3.74zm-3.32 3.32-2.02 2.019a4.25 4.25 0 0 1-5.44 5.44l-1.187 1.188a9.7 9.7 0 0 0 2.628.373c3.768 0 7.483-2.38 8.616-5.26a.74.74 0 0 0 0-.542c-.475-1.206-1.403-2.325-2.598-3.218",
    clipRule: "evenodd"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    d: "M15.965 5.237A11.4 11.4 0 0 0 12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64c.578 1.47 1.661 2.788 3.036 3.827l1.073-1.073c-1.25-.906-2.224-2.058-2.714-3.303a.74.74 0 0 1 0-.542C4.517 8.381 8.232 6 12 6c.944 0 1.885.15 2.784.42z"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    d: "M13.63 7.573a4.25 4.25 0 0 0-5.556 5.556l1.208-1.208a2.75 2.75 0 0 1 3.139-3.139z"
  }));
}
var oe = R(/* @__PURE__ */ f(se));
function ue(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 7.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5M9.25 11.5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
    clipRule: "evenodd"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64C3.384 15.9 7.724 18.562 12 18.562c4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64C20.616 7.162 16.275 4.5 12 4.5m-8.617 6.76C4.517 8.382 8.232 6 12 6s7.483 2.381 8.616 5.26a.74.74 0 0 1 0 .542c-1.133 2.88-4.848 5.26-8.616 5.26s-7.483-2.38-8.617-5.26a.74.74 0 0 1 0-.541",
    clipRule: "evenodd"
  }));
}
var ce = R(/* @__PURE__ */ f(ue));
const pe = ["default", "large"], de = A(["border border-solid relative flex items-center rounded-12 py-4 px-16"], {
  variants: {
    mobileSize: {
      default: "min-h-44",
      large: "min-h-56"
    },
    pcSize: {
      default: "pc:min-h-44",
      large: "pc:min-h-56"
    },
    isFocused: {
      true: "border px-15",
      false: ""
    },
    disabled: {
      true: "bg-fill-neutral-weak",
      false: "bg-static-white"
    },
    isShowRightIconButton: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    ...pe.flatMap((e) => [
      {
        isFocused: !1,
        mobileSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pr-8" : "rounded-16 pr-10"
      },
      {
        isFocused: !0,
        mobileSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pr-7" : "rounded-16 pr-9"
      },
      {
        isFocused: !1,
        pcSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pc:pr-8" : "rounded-16 pc:pr-10"
      },
      {
        isFocused: !0,
        pcSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pc:pr-7" : "rounded-16 pc:pr-9"
      }
    ])
  ],
  defaultVariants: {
    mobileSize: "default",
    pcSize: "default",
    isShowRightIconButton: !1,
    isFocused: !1
  }
}), me = A(
  [
    "size-full placeholder:text-text-neutral-medium text-text-neutral-main disabled:text-interaction-neutral-disable-main disabled:placeholder:text-interaction-neutral-disable-main disabled:bg-fill-neutral-weak",
    // number 타입 input의 화살표 숨김
    "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
  ],
  {
    variants: {
      mobileSize: {
        default: "typography-subtitle-16-regular",
        large: "typography-subtitle-18-regular"
      },
      pcSize: {
        default: "pc:typography-subtitle-16-regular",
        large: "pc:typography-subtitle-18-regular"
      }
    },
    defaultVariants: {
      mobileSize: "default",
      pcSize: "default"
    }
  }
), fe = (e) => re(e) && e.type === "button", he = ({ children: e }) => fe(e) ? te(e, { tabIndex: -1 }) : e, C = f(
  ({
    id: e,
    type: r = "text",
    value: n,
    disabled: l,
    onChange: s,
    onBlur: o,
    hasError: u = !1,
    placeholder: h,
    mobileSize: d = "default",
    pcSize: m = "default",
    rightTextButton: v,
    onClearCallback: y,
    onPasswordToggleCallback: S,
    showPasswordVisibleButton: E,
    showClearButton: D = !1,
    inputWrapperClassName: k,
    inputClassName: M,
    suffix: B,
    ...q
  }, G) => {
    var T, W;
    const i = $(null), { isFocused: I } = le(i);
    P(G, () => i.current);
    const V = g(() => d === "default" ? "small" : "medium", [d]), z = g(() => m === "default" ? "small" : "medium", [m]), [w, J] = ee(!1), K = de({
      disabled: l,
      mobileSize: d,
      pcSize: m,
      isFocused: I,
      isShowRightIconButton: !!(D || E)
    }), N = me({ mobileSize: d, pcSize: m }), Q = g(() => l ? "border-line-neutral-weak3" : u ? "border-line-danger-main caret-text-danger-main" : I ? "border-line-primary-main caret-fill-primary-main" : "border-line-neutral-weak3", [l, u, I]), U = (a) => {
      o == null || o(a);
    }, X = (a) => {
      a.preventDefault();
      const b = i.current;
      b && (b.value = "", j(), s && s({
        target: b,
        currentTarget: b
      })), y == null || y();
    }, j = () => {
      if (i.current) {
        const a = i.current.value.length || (n == null ? void 0 : n.toString().length) || 0;
        window.setTimeout(() => {
          i.current && i.current.setSelectionRange(a, a);
        }, 0), i.current.focus();
      }
    }, Y = () => {
      J(!w), j(), S == null || S();
    }, Z = (a) => {
      s == null || s(a);
    }, _ = g(() => r === "password" ? w ? "text" : "password" : r, [r, w]);
    return /* @__PURE__ */ x("div", { className: p(K, Q, k), children: [
      /* @__PURE__ */ t(
        "input",
        {
          className: p(N, M),
          disabled: l,
          id: e,
          onBlur: U,
          onChange: Z,
          placeholder: h,
          ref: i,
          type: _,
          value: n,
          ...q
        }
      ),
      B && (n || (T = i.current) != null && T.value) ? /* @__PURE__ */ x("div", { className: "pointer-events-none absolute left-0 top-0 flex h-full items-center", children: [
        /* @__PURE__ */ t("span", { className: p(N, M, "invisible"), children: n }),
        /* @__PURE__ */ t(
          "span",
          {
            className: p(
              N,
              "text-text-tertiary ml-22 flex items-center",
              l ? "text-interaction-neutral-disable-main" : ""
            ),
            children: B
          }
        )
      ] }) : null,
      l ? null : /* @__PURE__ */ t(L, { children: v ? /* @__PURE__ */ t(he, { children: /* @__PURE__ */ t("div", { className: "pl-8", children: v }) }) : (n || ((W = i.current) == null ? void 0 : W.value)) && /* @__PURE__ */ x(L, { children: [
        D ? /* @__PURE__ */ t(
          O,
          {
            icon: /* @__PURE__ */ t(ie, {}),
            onClick: X,
            onMouseDown: (a) => {
              a.preventDefault();
            },
            size: { mobile: V, pc: z },
            tabIndex: -1,
            theme: "ghost"
          }
        ) : null,
        r === "password" && E ? /* @__PURE__ */ t(
          O,
          {
            icon: w ? /* @__PURE__ */ t(ce, {}) : /* @__PURE__ */ t(oe, {}),
            onClick: Y,
            onMouseDown: (a) => {
              a.preventDefault();
            },
            size: { mobile: V, pc: z },
            tabIndex: -1,
            theme: "ghost"
          }
        ) : null
      ] }) })
    ] });
  }
);
C.displayName = "NDS.Input";
const H = f(({ children: e, ...r }, n) => /* @__PURE__ */ t("label", { ref: n, ...r, className: "flex-start flex px-4", children: typeof e == "string" ? /* @__PURE__ */ t("span", { className: "text-text-neutral-main typography-body-13-semibold", children: e }) : e }));
H.displayName = "NDS.Label";
const F = ({ leftContent: e, rightContent: r, hasError: n, disabled: l }) => {
  const s = g(() => l ? "text-interaction-neutral-disable-main" : n ? "text-text-danger-main" : "text-text-neutral-main", [l, n]), o = (u, h) => typeof u == "string" ? /* @__PURE__ */ t("span", { className: h, children: u }) : u;
  return /* @__PURE__ */ x("div", { className: "flex w-full justify-between px-4 text-left", children: [
    e ? /* @__PURE__ */ t("div", { className: "mr-8", children: o(e, p("line-clamp-2 typography-body-12-regular-multiline", s)) }) : null,
    r ? /* @__PURE__ */ t("div", { className: "ml-auto", children: o(r, p("whitespace-nowrap text-text-neutral-main typography-body-12-regular")) }) : null
  ] });
};
F.displayName = "NDS.Support";
ne(F);
const ge = f(
  ({
    className: e,
    id: r,
    label: n,
    supportLeftContent: l,
    supportRightContent: s,
    hasError: o = !1,
    disabled: u = !1,
    inputRef: h,
    suffix: d,
    ...m
  }, v) => /* @__PURE__ */ x("div", { className: p("flex w-full flex-col gap-8", e), ref: v, children: [
    n ? /* @__PURE__ */ t(H, { htmlFor: r, children: n }) : null,
    /* @__PURE__ */ t(C, { disabled: u, hasError: o, id: r, ref: h, suffix: d, ...m }),
    l || s ? /* @__PURE__ */ t(
      F,
      {
        disabled: u,
        hasError: o,
        leftContent: l,
        rightContent: s
      }
    ) : null
  ] })
);
ge.displayName = "NDS.TextField";
export {
  ge as T
};
